import React, { createContext, useContext, useEffect, useState } from "react";

const CompareContext = createContext(null);
const STORAGE_KEY = "msm_compare_slugs";
const MAX = 5;

export function CompareProvider({ children }) {
  const [slugs, setSlugs] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  const [toastMessage, setToastMessage] = useState(null);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(slugs));
    } catch {
      /* ignore */
    }
  }, [slugs]);

  const isInCompare = (slug) => slugs.includes(slug);

  const toggleCompare = (slug) => {
    if (slugs.includes(slug)) {
      setSlugs((prev) => prev.filter((s) => s !== slug));
      return;
    }
    if (slugs.length >= MAX) {
      setToastMessage("Maksimal 5 sekolah dapat dibandingkan. Hapus salah satu pilihan terlebih dahulu.");
      setTimeout(() => setToastMessage(null), 3000);
      return;
    }
    setSlugs((prev) => [...prev, slug]);
  };

  const removeCompare = (slug) => setSlugs((prev) => prev.filter((s) => s !== slug));
  const clearCompare = () => setSlugs([]);

  return (
    <CompareContext.Provider
      value={{ slugs, isInCompare, toggleCompare, removeCompare, clearCompare, max: MAX, count: slugs.length }}
    >
      {children}
      {toastMessage && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-ink text-warm ink-border rounded-xl px-5 py-3 shadow-offset-sm animate-fade-up text-sm font-bold text-center max-w-[90vw]">
          {toastMessage}
        </div>
      )}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const ctx = useContext(CompareContext);
  if (!ctx) throw new Error("useCompare must be used within CompareProvider");
  return ctx;
}
